import { ESTACIO_INICIALITZAR,
    ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_EN_CURS,
    ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_FINALITZADA } from '../../../actions/actionTypes';

export const ESTAT_INICIAL = false;

const peticioObtenirEstructuraEnCurs = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case ESTACIO_INICIALITZAR:
            return ESTAT_INICIAL;

        case ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_EN_CURS:
            return true;

        case ESTACIO_INTRODUCCIO_OBTENIR_ESTRUCTURA_FINALITZADA:
            return false;

        default:
            return state;
    }
};

export default peticioObtenirEstructuraEnCurs;



// WEBPACK FOOTER //
// ./src/reducers/estacio/formulari/peticioObtenirEstructuraEnCurs.js